import { Component, ComponentFactoryResolver, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { EventEmitter } from '@angular/core';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { AuthenticationResult } from '../../../shared/models/authentication-result';
import { AppStore } from '../../../shared/store/lookup-store.service';
import { UiStateStore } from '../../../shared/store/ui-state-store.service';
import { CandidateSummary } from '../../models/candidate-summary';
import { ProfileBookmark } from '../../models/profile-bookmark';
import { DataService } from '../../services/data.service';
import { CandidatesStore } from '../../store/candidates-store.service';
import { ResumePreviewComponent } from '../resume-preview/resume-preview.component';

@Component({
  selector: 'candidates-list',
  templateUrl: './candidates-list.component.html',
  styleUrls: ['./candidates-list.component.scss']
})
export class CandidatesListComponent implements OnInit, OnDestroy {
  @Output() candidateSelected = new EventEmitter<string>();
  @Input("candidates") candidates: Observable<CandidateSummary[]>;
  @Input() totalPageCount: Observable<number>;
  @Input("showSalary") showSalary: boolean;
  @Input("showBookmark") showBookmark: boolean;

  photoPath: string = "assets/images/avatar/04.jpg";
  user: AuthenticationResult = null;
  subscriptions: Subscription[] = [];
  candidateSummaries: CandidateSummary[] = [];
  profileBookmarks: ProfileBookmark[] = [];

  constructor(
    private uiStore: UiStateStore,
    private dataService: DataService,
    public lookupStore: AppStore,
    private candidatesStore: CandidatesStore,
    private modalService: NgbModal,
    private resolver: ComponentFactoryResolver) { }

  ngOnInit() {
    let userSubscription = this.uiStore.authenticatedUser.subscribe(user => {
      if (!user) {
        return;
      }

      this.user = user;
    });

    this.subscriptions.push(userSubscription);

    let candidatesSubscription = this.candidates.subscribe(candidates => {
      this.candidateSummaries = candidates;
      if(!this.user) {
        return;
      }

      let profileBookmarkSubscription = this.dataService.getProfileBookmarks(this.user.accountId).subscribe(pbm => {
        if (!pbm) {
          return;
        }

        this.profileBookmarks = pbm;
        let filteredCandidates = candidates.filter(c => this.profileBookmarks.findIndex(pb => pb.profileId == c.profileId) > -1);
        if (filteredCandidates.length > 0) {
          filteredCandidates.forEach(fc => fc.bookmarked = true);
        }
      });

      this.subscriptions.push(profileBookmarkSubscription);
    });

    this.subscriptions.push(candidatesSubscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onShortListClicked(profileId: string) {
    let profileBookmark = this.profileBookmarks.find(pb => pb.profileId == profileId);
    if(!profileBookmark) {
      let bookmark = { profileId, accountId: this.user.accountId } as ProfileBookmark
      this.dataService.bookmarkCandidate(bookmark).subscribe(pb => {
        this.profileBookmarks.push(pb);
        let candidate = this.candidateSummaries.find(cs => cs.profileId == profileId);
        candidate.bookmarked = true;
      });
      return false;
    }

    this.dataService.unBookmarkCandidate(profileBookmark.id).subscribe(r => {
      let candidate = this.candidateSummaries.find(cs => cs.profileId == profileId);
      candidate.bookmarked = false;
      let index = this.profileBookmarks.indexOf(profileBookmark);
      this.profileBookmarks.splice(index, 1);
    });

    return false;
  }

  getRateType(salaryTypeId: string): string {
    let salaryType = this.lookupStore.getSalaryType(salaryTypeId)?.value;
    switch(salaryType) {
      case "Hourly": {
        return "hour";
      }
      case "Annual": {
        return "year";
      }
      case "Daily": {
        return "day"
      }
      default: {
        return salaryType;
      }
    }
  }

  viewResume(resumeId: string): void {
    const componentFactory = this.resolver.resolveComponentFactory(ResumePreviewComponent);
    const modalRef = this.modalService.open(ModalComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.setContent(componentFactory);

    this.candidatesStore.getResume(resumeId);
  }

  selectCandidate(selectedAccountId: string): void {
    this.candidateSelected.emit(selectedAccountId);
  }

}
